export default __webpack_public_path__ + "media/images/features/saga/title_background_sp-1a572c306bf8160eb7aef7b67070b034.png";